import classNames from 'classnames'
import React, { useState } from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { BiSolidDownArrow, BiSolidUpArrow } from 'react-icons/bi'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { DietDetails } from '../../api/services/dietbase/types.ts'
import { OrderDetailsType } from '../../api/services/orders/types.ts'
import Alert from '../../components/common/Alert/Alert.tsx'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Button from '../../components/common/Button/Button.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Loader from '../../components/common/Loader/Loader.tsx'
import DietSelector from '../../components/diets/DietSelector/DietSelector.tsx'
import DietDetailsPopup from '../daymenus/popup'

type Props = {
  setIsPopupVisible: React.Dispatch<React.SetStateAction<boolean>>
  setChangeStatus: React.Dispatch<React.SetStateAction<boolean>>
}
const OrderRealization = (props: Props) => {
  const { orderId } = useParams<{ orderId: string }>()

  const navigate = useNavigate()
  const location = useLocation()
  const order: OrderDetailsType | null = location.state?.order

  const [dietLoading, setDietLoading] = useState(false)
  const [optionSharingDiet, setOptionSharingDiet] = useState<
    'folder' | 'diet' | null
  >(null)
  const [selectedFolder, setSelectedFolder] = useState<number | null>(null)
  const [selectedDietID, setSelectedDietID] = useState<number | null>(null)
  const [dietDetails, setDietDetails] = useState<
    DietDetails | null | undefined
  >(null)

  const [isSqueezed, setIsSqueezed] = useState(true)

  const onCloseHandler = () => {
    navigate(`/orders/${orderId}`)
  }

  const onExpandHandler = () => {
    setIsSqueezed(!isSqueezed)
  }

  const getDietDetails = async (
    details: DietDetails | null,
    dietID: number | null
  ) => {
    setDietDetails(details)
    setSelectedDietID(dietID)
  }

  const getStatusLoadingDietList = (status: boolean) => {
    setDietLoading(status)
  }

  const getOptionSharingDiet = (option: 'folder' | 'diet' | null) => {
    setOptionSharingDiet(option)
  }

  const getSelectedFolder = (folder: number | null) => {
    setSelectedFolder(folder)
  }

  return (
    <div>
      <Breadcrumbs
        pageName={`Udostępnianie diety dla zamówienia nr ${orderId}`}
        breadcrumbs={[
          { label: 'Zamówienia', path: '/orders' },
          { label: `Numer: ${orderId}`, path: `/orders/${orderId}` },
          { label: 'Udostępnianie diety' }
        ]}
      />

      <div className="flex w-full 2xl:flex-row flex-col gap-4">
        <Card className="w-full">
          <Card.Title>
            <div className="flex flex-row items-center justify-between">
              <h2 className="text-xl font-semibold text-center md:text-left">
                {'Wybierz folder z dietami dla pacjenta'}
              </h2>
              <Button
                variant="filled"
                size="medium"
                color="primary"
                type="button"
                onClick={onCloseHandler}
                className="px-4 py-2 bg-red-500 text-white rounded-md shadow-md hover:bg-red-600 transition-colors"
              >
                Wróć do zamówienia
              </Button>
            </div>
          </Card.Title>
          <div className="w-full max-h-[600px] overflow-auto">
            <DietSelector
              isPopup={false}
              order={order}
              setChangeStatus={props.setChangeStatus}
              onClose={onCloseHandler}
              getSelectedFolder={getSelectedFolder}
              getDietDetails={getDietDetails}
              selectedDietID={selectedDietID}
              getStatusLoadingDietList={getStatusLoadingDietList}
              getOptionSharingDiet={getOptionSharingDiet}
            />
          </div>
        </Card>

        <div className={'w-full 2xl:w-1/2 box-border'}>
          <Card className={classNames('w-full  box-border')}>
            <Card.Title>
              <div className="flex flex-row items-center justify-between">
                <h2 className="text-xl font-semibold text-center md:text-left py-2.5">
                  {'Podgląd wybranej diety'}
                </h2>
                {dietDetails && (
                  <Button
                    variant="filled"
                    size="medium"
                    color="primary"
                    type="button"
                    onClick={onExpandHandler}
                    icon={
                      isSqueezed ? <BiSolidDownArrow /> : <BiSolidUpArrow />
                    }
                  >
                    {isSqueezed ? 'Rozwiń' : 'Zwiń'}
                  </Button>
                )}
              </div>
            </Card.Title>
            {dietLoading && (
              <div className={'flex-col items-center justify-center mt-10'}>
                <Loader size="large" />
                <p className={'w-full text-center'}>Proszę czekać...</p>
              </div>
            )}
            {!dietLoading && !dietDetails && (
              <Alert
                type="info"
                message={
                  optionSharingDiet === 'diet'
                    ? selectedFolder
                      ? 'Wybierz dietę'
                      : 'Wybierz folder'
                    : 'Podgląd diety jest dostępny gdy wybierzemy udostępnianie wybranej diety zamiast całego folderu'
                }
                icon={<AiOutlineInfoCircle className="text-lg" />}
              />
            )}
            {dietDetails && !dietLoading && (
              <div className="w-full max-h-[600px] overflow-auto">
                <DietDetailsPopup
                  isPopup={false}
                  isSqueezed={isSqueezed}
                  dietDetails={dietDetails as DietDetails}
                />
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  )
}

export default OrderRealization
